
import './App.css';
import Footer from './components/Footer';
import Home from './components/Home';
import Nav from './components/Nav';
import React, { useState } from "react";

import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import BattlePass from './components/BattlePass';
import Venom from './components/Venom';
import Fabio from './components/Fabio';
import CHIMPANSKI from './components/CHIMPANSKI';
import CHARLOTTE from './components/CHARLOTTE';
import KOR from './components/KOR';
import TOONAFISH from './components/TOONAFISH';
import CoomingSoon from './components/CoomingSoon';
import Crew from './components/Crew';
import Sign from './components/Sign';


function App() {
  return (
    <Router>
      <div className="App">

        <Switch>

          <Route exact path="/">
            <Nav img_logo1="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
              img_logo2="https://pngimg.com/uploads/fortnite/fortnite_PNG25.png"
            />
            <Home  />
            <Footer />
          </Route>


          <Route exact path="/battlePass">
            <Nav img_logo1="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
              img_logo2="https://pngimg.com/uploads/fortnite/fortnite_PNG25.png"
            />
            <BattlePass />
            <Footer />
          </Route>

          <Route exact path="/venom">
            <Nav img_logo1="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
              img_logo2="https://pngimg.com/uploads/fortnite/fortnite_PNG25.png"
            />
            <Venom />
            <Footer />
          </Route>

          <Route exact path="/fabio">
            <Nav img_logo1="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
              img_logo2="https://pngimg.com/uploads/fortnite/fortnite_PNG25.png"
            />
            <Fabio />
            <Footer />
          </Route>

          <Route exact path="/chimpanski">
            <Nav img_logo1="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
              img_logo2="https://pngimg.com/uploads/fortnite/fortnite_PNG25.png"
            />
            < CHIMPANSKI />
            <Footer />
          </Route>

          <Route exact path="/charlotte">
            <Nav img_logo1="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
              img_logo2="https://pngimg.com/uploads/fortnite/fortnite_PNG25.png"
            />
            < CHARLOTTE />
            <Footer />
          </Route>

          <Route exact path="/kor">
            <Nav img_logo1="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
              img_logo2="https://pngimg.com/uploads/fortnite/fortnite_PNG25.png"
            />
            <KOR />
            <Footer />
          </Route>

          <Route exact path="/toonafish">
            <Nav img_logo1="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
              img_logo2=      "https://pngimg.com/uploads/fortnite/fortnite_PNG25.png"
            />
            <TOONAFISH />
            <Footer />
          </Route>

          <Route exact path="/coomingSoon">
            <Nav img_logo1="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
              img_logo2="https://pngimg.com/uploads/fortnite/fortnite_PNG25.png"
            />
            <CoomingSoon />
            <Footer />
          </Route>

          <Route exact path="/crew">
            <Nav img_logo1="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
              img_logo2="https://pngimg.com/uploads/fortnite/fortnite_PNG25.png"
            />
            <Crew />
            <Footer />
          </Route>
          <Route>
            <Sign exat path="/sign"/>
          </Route>
        </Switch>

      </div>
    </Router>

  );
}

export default App;
